const root = state => state.legalConsentOptions;
export const getDefaultLegalConsentOption = state => root(state).defaultLegalConsentOption;
export const getDefaultLegalConsentOptionRequestState = state => root(state).defaultLegalConsentOptionRequestState;